

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P13-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page9/E1/Key/answerKey.png',
    titleImage: '',
    hideBtnFooter: true,
    questionImage: [ // Row
      [
        // Column 1
        { url: 'img/FriendsPlus/Page13/E1/1.jpg' },
      ],
      [
        // Column 2
        { url: 'img/FriendsPlus/Page13/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page13/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/5.jpg', input: 2 },
      ],
      [
        // Column 3
        { url: 'img/FriendsPlus/Page13/E1/6.jpg' },
      ],
      [
        // Column 4
        { url: 'img/FriendsPlus/Page13/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/8.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page13/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/10.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page13/E1/11.jpg' },
      ]
    ],
  },
  2: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P13-E3',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page13/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page13/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page13/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page13/E2/3.jpg', input: true, answer: "Her name's Lola." },
        { url: 'img/FriendsPlus/Page13/E2/4.jpg' },

      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page13/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page13/E2/6.jpg', input: true, answer: "What's on her shelf?" },
        { url: 'img/FriendsPlus/Page13/E2/7.jpg' },

      ],
    ],
  },

  3: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P13-E3',
    audio: '',
    video: '',
    component: D1,
    maxLength: 1,
    hideBtnFooter: true,
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page13/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page13/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page13/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/5.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/11.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/13.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/14.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page13/E3/15.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page13/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/17.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/19.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/20.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/21.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/22.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/23.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/24.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/25.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/26.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/27.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E3/28.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page13/E3/29.jpg' },
      ],
    ],
  },

  4: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P13-E4',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page13/E4/0.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page13/E4/3.jpg', input: true, answer: "This is Rosy's cousin" },
        { url: 'img/FriendsPlus/Page13/E4/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/5.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page13/E4/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E4/8.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/9.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/10.jpg' },
        { url: 'img/FriendsPlus/Page13/E4/11.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E4/12.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/13.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/14.jpg' },
        { url: 'img/FriendsPlus/Page13/E4/15.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E4/16.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/17.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/18.jpg' },
        { url: 'img/FriendsPlus/Page13/E4/19.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E4/20.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/21.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/22.jpg' },
        { url: 'img/FriendsPlus/Page13/E4/23.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page13/E4/24.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page13/E4/25.jpg' },
      ],
    ],
  },
}

export default json;